import AssetService from '../../services/AssetService';
import ExcelJS from 'exceljs'
import logoBase64 from "../../imgs/mohLogo";
import util from "../util"; 
import UserService from '../../services/UserService';

import {
    message
} from 'antd';

const Title = "Ministry Of Health Asset Register";
const primaryColor = '#1B4E72';      // Professional blue
const secondaryColor = '#2E86AB';    // Lighter blue
const accentColor = '#A23B72';       // Burgundy accent
const successColor = '#28A745';      // Green for status
const warningColor = '#FFC107';      // Amber for warnings
const dangerColor = '#DC3545';       // Red for critical
const lightGray = '#F8F9FA';         // Light background
const darkGray = '#495057';          // Dark text
const headerGradient = '#1B4E72';    // Header gradient start

const formHeader = "Form S.S.21"; 
const usernameTag = "Officer Name & Surname";
const designationTag = "Designation";

var UseDetails = ""; 
var UserDesignation = "";
var nonMedic = null;
var assetsTotalsByCategory = null;
var assetsTotalsByFunctionalStatus = null;
var infrastructure = null;
const dateToday = util.getCurrentDateTime();

// Enhanced configuration for different asset types
const ASSET_CONFIGS = {
    '8': {
        name: 'Vehicle Fleet',
        title: 'VEHICLE MANAGEMENT DASHBOARD',
        subtitle: 'Comprehensive Fleet Overview & Status Report',
        filename: 'MoH_Vehicle_Asset_Register.xlsx',
        icon: '🚗',
        color: primaryColor,
        headers: {
            site_code: 'RC CODE',
            facility: 'FACILITY NAME',
            serial_no: 'REGISTRATION NO.',
            item_name: 'MAKE & MODEL',
            eieftnumber: 'Engine Number',
            order_number: 'CHASSIS NO.',
            delivery_note_number: 'MILEAGE (KM)',
            created: 'LAST MILEAGE UPDATE',
            functional_status_name: 'VEHICLE STATUS',
            eistatus: 'MAINTENANCE REQUIRED',
            model: 'MODEL VARIANT',
            type: 'VEHICLE TYPE',
            station_points: 'LOCATION/DEPT',
            eicomment: 'REMARKS & NOTES',  
        },
        functionalStatuses: ['Fair', 'Good condition', 'Waiting for repairs', 'Awaiting for disposal'],
        statusColors: {
            'Good condition': successColor,
            'Fair': warningColor,
            'Waiting for repairs': dangerColor,
            'Awaiting for disposal': darkGray
        }
    },
    '9': {
        name: 'Medical Supplies',
        title: 'SUPPLIES INVENTORY MANAGEMENT',
        subtitle: 'Stock Control & Expiry Tracking System',
        filename: 'MoH_Supplies_Asset_Register.xlsx',
        icon: '📦',
        color: accentColor,
        headers: {
            site_code: 'RC CODE',
            facility: 'FACILITY NAME',
            serial_no: 'ITEM IDENTIFIER',
            item_name: 'SUPPLY ITEM',
            functional_status_name: 'CURRENT STATUS',
            procurement_date: 'EXPIRY DATE',
            stock: 'QUANTITY',
            installation_date: 'ISSUE DATE',
            station_points: 'STORAGE LOCATION',
            model: 'BRAND/MANUFACTURER',
            type: 'CATEGORY TYPE',
            created: 'RECORDED DATE',
            eicomment: 'NOTES & REMARKS', 
        },
        functionalStatuses: ['Usable', 'Expired'],
        statusColors: {
            'Usable': successColor,
            'Expired': dangerColor
        }
    },
    '3': {
        name: 'Medical Equipment',
        title: 'MEDICAL EQUIPMENT REGISTRY',
        subtitle: 'Clinical Equipment Management & Maintenance',
        filename: 'MoH_Medical_Equipment_Register.xlsx',
        icon: '',
        color: secondaryColor,
        headers: {
            site_code: 'RC CODE',
            facility: 'FACILITY NAME',
            serial_no: 'EQUIPMENT ID',
            item_name: 'EQUIPMENT NAME',
            stock: 'QUANTITY',
            functional_status_name: 'OPERATIONAL STATUS',
            station_points: 'DEPARTMENT/WARD',
            procurement_date: 'RECEIVED DATE',
            installation_date: 'INSTALLATION DATE',
            model: 'MODEL/BRAND',
            type: 'EQUIPMENT TYPE',
            manufacturer: 'MANUFACTURER',
            eicomment: 'SERVICE NOTES'
        },
        functionalStatuses: ['Serviceable', 'Partial functional', 'Installed', 'Not installed', 'Unserviceable', 'Boarded'],
        statusColors: {
            'Serviceable': successColor,
            'Partial functional': warningColor,
            'Installed': '#17A2B8',
            'Not installed': '#FD7E14',
            'Unserviceable': dangerColor,
            'Boarded': darkGray
        }
    },
    '2': {
        name: 'Non-Medical Assets',
        title: 'NON-MEDICAL EQUIPMENT REGISTRY',
        subtitle: 'Administrative & Support Equipment Management',
        filename: 'MoH_NonMedical_Equipment_Register.xlsx',
        icon: '🏢',
        color: '#6F42C1',
        headers: {
            site_code: 'RC CODE',
            facility: 'FACILITY NAME',
            serial_no: 'ASSET IDENTIFIER',
            item_name: 'EQUIPMENT NAME',
            isdonated: 'DONATED?',
            procurement_date: 'RECEIVED YEAR',
            stock: 'QUANTITY',
            functional_status_name: 'CURRENT STATUS',
            station_points: 'CURRENT LOCATION',
            eicomment: 'MAINTENANCE NOTES'
        },
        functionalStatuses: ['Serviceable', 'Partial functional', 'Installed', 'Not installed', 'Unserviceable', 'Boarded'],
        statusColors: {
            'Serviceable': successColor,
            'Partial functional': warningColor,
            'Installed': '#17A2B8',
            'Not installed': '#FD7E14',
            'Unserviceable': dangerColor,
            'Boarded': darkGray
        }
    }
};

class EnhancedExcelReportUtil {

    generateStockTransactionsReport = async(sdataRef) => {
        // Await the user details before proceeding
        await this.getLoggedInUserNameAndSurnameAndDesignation();
        
        const assetCatId = sdataRef.current.asset_cat_id;
        const config = ASSET_CONFIGS[assetCatId];
        
        if (!config) {
            message.error(`Unsupported asset category: ${assetCatId}`);
            return;
        }

        const dynamicTitle = `Ministry Of Health ${config.name} Asset Register`;
        
        assetsTotalsByCategory = await AssetService.getTotalsByAssetCategory();
        assetsTotalsByFunctionalStatus = await AssetService.getTotalByAssetFunctionalStatus(); 

        console.log("Data being sent to getAssetInventoryReportData:", sdataRef.current);
        
        const requestData = {
            asset_cat_id: assetCatId,
            all: 'ALL'
        };
        
        console.log("Final request data:", requestData);

        AssetService.getAssetInventoryReportData(requestData).then(async({ data }) => {
            console.log("Raw API Response:", data);
            
            let actualData;
            if (data && data.result) {
                actualData = data.result;
            } else if (Array.isArray(data)) {
                actualData = data;
            } else {
                console.error("Unexpected data structure:", data);
                message.error("Unexpected data structure received from server");
                return;
            }
            
            console.log("Processed data:", actualData);
            
            const workbook = new ExcelJS.Workbook();
            
            // Enhanced workbook properties
            workbook.creator = 'Ministry of Health - Inventory Management';
            workbook.lastModifiedBy = UseDetails || 'MoH Officer';
            workbook.created = new Date();
            workbook.modified = new Date();
            workbook.lastPrinted = new Date();
            workbook.properties.date1904 = true;
            workbook.views = [
                {
                    x: 0, y: 0, width: 10000, height: 20000,
                    firstSheet: 0, activeTab: 0, visibility: 'visible'
                }
            ];

            const sheet = workbook.addWorksheet('Asset Register', {
                pageSetup: {
                    paperSize: 9, // A4
                    orientation: 'landscape',
                    fitToPage: true,
                    fitToHeight: 1,
                    fitToWidth: 1
                }
            });

            // Set sheet properties
            sheet.properties.defaultRowHeight = 18;
            sheet.properties.defaultColWidth = 12;
            
            this.createEnhancedReport(sheet, { result: actualData }, config, dynamicTitle);
            
            const image = new Image();
            image.src = `data:image/png;base64,${logoBase64}`;
            image.onload = function () {
                const canvas = document.createElement('canvas');
                canvas.width = image.width;
                canvas.height = image.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(image, 0, 0);
                canvas.toBlob(async function (blob) {
                    const arrayBuffer = await blob.arrayBuffer();
                    const imageId = workbook.addImage({
                        buffer: new Uint8Array(arrayBuffer),
                        extension: 'png',
                    });

                    // Enhanced logo placement
                    sheet.addImage(imageId, {
                        tl: { col: 0.2, row: 1.2 }, 
                        ext: { width: 80, height: 60 }
                    });

                    const bufferData = await workbook.xlsx.writeBuffer();
                    const downloadBlob = new Blob([bufferData], { 
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                    });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(downloadBlob);
                    link.download = config.filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);  
                }, 'image/png');   
            }
        });
    }

    createEnhancedReport(sheet, data, config, title) {
        // Calculate statistics first
        const stats = this.calculateDetailedStatistics(data.result, config);
        
        // Track row positions to prevent overlaps
        let currentRow = 1;
        
        // Create the enhanced header section
        this.createModernHeader(sheet, config, title);
        currentRow = 7; // Header uses rows 1-6
        
        // Create the main data table (moved up, right after header)
        this.createEnhancedDataTable(sheet, data, config, 8); // Start at row 8
        
        // Calculate actual end row of data table
        const dataRowCount = data.result ? data.result.length : 0;
        currentRow = Math.max(15, 9 + dataRowCount); // Data table starts at row 8 now
        
        // Create officer information section (moved below data table)
        this.createOfficerInfoSection(sheet, config, currentRow + 2);
        currentRow += 7; // Officer info takes about 5 rows
        
        // Create executive summary with proper spacing
        this.createExecutiveSummaryAtRow(sheet, data, config, stats, currentRow + 2);
        currentRow += 10; // Executive summary takes about 8 rows
        
        // Create footer section with proper spacing
        this.createFooterSectionAtRow(sheet, config, currentRow + 2);
        currentRow += 5; // Footer takes about 3 rows
        
        // Add data validation with proper spacing
        this.addDataValidationAtRow(sheet, config, currentRow + 2);
        
        // Apply final formatting
        this.applyFinalFormatting(sheet, config);
    }

    createModernHeader(sheet, config, title) {
        // Create gradient-like header background
        for (let row = 1; row <= 6; row++) {
            for (let col = 1; col <= 15; col++) {
                const cell = sheet.getCell(row, col);
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: config.color.replace('#', '') }
                };
            }
        }
        
        // Merge cells for main title (rows 1-3)
        sheet.mergeCells('A1:O3');
        
        // Main title
        const titleCell = sheet.getCell('A1');
        titleCell.value = `${config.icon} ${config.title}`;
        titleCell.font = { 
            size: 24, 
            bold: true, 
            color: { argb: 'FFFFFF' },
            name: 'Calibri'
        };
        titleCell.alignment = { 
            horizontal: 'center', 
            vertical: 'middle' 
        };
        
        // Subtitle (row 4)
        sheet.mergeCells('A4:O4');
        const subtitleCell = sheet.getCell('A4');
        subtitleCell.value = config.subtitle;
        subtitleCell.font = { 
            size: 14, 
            italic: true, 
            color: { argb: 'FFFFFF' },
            name: 'Calibri'
        };
        subtitleCell.alignment = { 
            horizontal: 'center', 
            vertical: 'middle' 
        };
        
        // Date and time (row 5)
        sheet.mergeCells('A5:O5');
        const dateCell = sheet.getCell('A5');
        dateCell.value = `Generated: ${util.getCurrentDateTime()}`;
        dateCell.font = { 
            size: 11, 
            color: { argb: 'FFFFFF' },
            name: 'Calibri'
        };
        dateCell.alignment = { 
            horizontal: 'center', 
            vertical: 'middle' 
        };
    }

    createOfficerInfoSection(sheet, config, startRow = 8) {
        // Form header
        const formCell = sheet.getCell(`A${startRow}`);
        formCell.value = formHeader;
        formCell.font = { size: 12, bold: true, name: 'Calibri' };
        formCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: lightGray.replace('#', '') }
        };
        
        // Officer information in a professional box layout
        const infoStartRow = startRow + 1;
        
        // Create bordered boxes for officer info
        for (let row = infoStartRow; row <= infoStartRow + 3; row++) {
            for (let col = 1; col <= 6; col++) {
                const cell = sheet.getCell(row, col);
                cell.border = {
                    top: { style: 'thin', color: { argb: darkGray.replace('#', '') } },
                    left: { style: 'thin', color: { argb: darkGray.replace('#', '') } },
                    bottom: { style: 'thin', color: { argb: darkGray.replace('#', '') } },
                    right: { style: 'thin', color: { argb: darkGray.replace('#', '') } }
                };
            }
        }
        
        // Officer name
        sheet.mergeCells(`A${infoStartRow}:B${infoStartRow}`);
        const nameHeaderCell = sheet.getCell(`A${infoStartRow}`);
        nameHeaderCell.value = usernameTag;
        nameHeaderCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: primaryColor.replace('#', '') }
        };
        nameHeaderCell.font = { 
            size: 11, 
            bold: true, 
            color: { argb: 'FFFFFF' },
            name: 'Calibri'
        };
        nameHeaderCell.alignment = { horizontal: 'center', vertical: 'middle' };
        
        sheet.mergeCells(`C${infoStartRow}:F${infoStartRow}`);
        const nameValueCell = sheet.getCell(`C${infoStartRow}`);
        nameValueCell.value = UseDetails || 'Not Available';
        nameValueCell.font = { size: 11, name: 'Calibri' };
        nameValueCell.alignment = { horizontal: 'left', vertical: 'middle' };
        
        // Designation
        sheet.mergeCells(`A${infoStartRow + 1}:B${infoStartRow + 1}`);
        const designationHeaderCell = sheet.getCell(`A${infoStartRow + 1}`);
        designationHeaderCell.value = designationTag;
        designationHeaderCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: primaryColor.replace('#', '') }
        };
        designationHeaderCell.font = { 
            size: 11, 
            bold: true, 
            color: { argb: 'FFFFFF' },
            name: 'Calibri'
        };
        designationHeaderCell.alignment = { horizontal: 'center', vertical: 'middle' };
        
        sheet.mergeCells(`C${infoStartRow + 1}:F${infoStartRow + 1}`);
        const designationValueCell = sheet.getCell(`C${infoStartRow + 1}`);
        designationValueCell.value = UserDesignation || 'Not Available';
        designationValueCell.font = { size: 11, name: 'Calibri' };
        designationValueCell.alignment = { horizontal: 'left', vertical: 'middle' };
    }

    createEnhancedDataTable(sheet, data, config, tableStartRow = 8) {
        const headers = Object.values(config.headers);
        const tableData = data.result;
        
        if (!tableData || tableData.length === 0) {
            sheet.getCell(`A${tableStartRow}`).value = 'No data available';
            return;
        }
        
        // Create table header - safe merge
        const headerRange = `A${tableStartRow - 1}:${String.fromCharCode(64 + headers.length)}${tableStartRow - 1}`;
        try {
            sheet.mergeCells(headerRange);
        } catch (error) {
            console.warn('Table header merge warning:', error.message);
        }
        
        const tableHeaderCell = sheet.getCell(`A${tableStartRow - 1}`);
        tableHeaderCell.value = `DETAILED ${config.name.toUpperCase()} REGISTRY`;
        tableHeaderCell.font = { 
            size: 14, 
            bold: true, 
            color: { argb: 'FFFFFF' },
            name: 'Calibri'
        };
        tableHeaderCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: config.color.replace('#', '') }
        };
        tableHeaderCell.alignment = { horizontal: 'center', vertical: 'middle' };
        
        // Column headers with enhanced styling
        headers.forEach((headerText, index) => {
            const cell = sheet.getCell(tableStartRow, index + 1);
            cell.value = headerText;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: primaryColor.replace('#', '') }
            };
            cell.font = {
                color: { argb: 'FFFFFF' },
                size: 9,
                bold: true,
                name: 'Calibri'
            };
            cell.alignment = { 
                horizontal: 'center', 
                vertical: 'middle',
                wrapText: true
            };
            cell.border = {
                top: { style: 'medium', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'medium', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
            
            // Auto-size columns
            const column = sheet.getColumn(index + 1);
            column.width = Math.max(headerText.length + 2, 12);
        });
        
        // Data rows with alternating colors and enhanced formatting
        tableData.forEach((item, rowIndex) => {
            const currentRow = tableStartRow + 1 + rowIndex;
            const isEvenRow = rowIndex % 2 === 0;
            
            Object.keys(config.headers).forEach((fieldName, colIndex) => {
                let cellValue = item[fieldName];
                const cell = sheet.getCell(currentRow, colIndex + 1);
                
                // Handle empty values
                if (cellValue === "" || cellValue === null || cellValue === undefined) {
                    cell.value = "N/A";
                    cell.font = { size: 9, italic: true, color: { argb: '6C757D' }, name: 'Calibri' };
                } else {
                    // Handle special field formatting
                    if (fieldName === "isdonated") {
                        cell.value = cellValue ? "No" : "Yes";
                        cell.font = { 
                            size: 9, 
                            bold: true, 
                            color: { argb: cellValue ? successColor.replace('#', '') : dangerColor.replace('#', '') },
                            name: 'Calibri'
                        };
                    } else if (fieldName === "station_points") {
                        if (Array.isArray(cellValue)) {
                            cell.value = cellValue.map(sp => sp.station_point).join(', ');
                        } else if (cellValue && typeof cellValue === 'string') {
                            cell.value = cellValue;
                        }
                        cell.font = { size: 9, name: 'Calibri' };
                    } else if (fieldName === "cost") {
                        if (cellValue && !isNaN(cellValue)) {
                            cell.value = this.formatCurrency(cellValue);
                            cell.font = { size: 9, bold: true, color: { argb: successColor.replace('#', '') }, name: 'Calibri' };
                        }
                    } else if (fieldName.includes('date') || fieldName.includes('expiry')) {
                        cell.value = this.formatDate(cellValue);
                        cell.font = { size: 9, name: 'Calibri' };
                    } else if (fieldName === "functional_status_name") {
                        cell.value = cellValue;
                        const statusColor = config.statusColors?.[cellValue] || darkGray;
                        cell.font = { 
                            size: 9, 
                            bold: true, 
                            color: { argb: statusColor.replace('#', '') },
                            name: 'Calibri'
                        };
                    } else {
                        cell.value = cellValue;
                        cell.font = { size: 9, name: 'Calibri' };
                    }
                }
                
                // Alternating row colors
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: isEvenRow ? 'FFFFFF' : 'F8F9FA' }
                };
                
                // Cell borders
                cell.border = {
                    top: { style: 'thin', color: { argb: 'DEE2E6' } },
                    left: { style: 'thin', color: { argb: 'DEE2E6' } },
                    bottom: { style: 'thin', color: { argb: 'DEE2E6' } },
                    right: { style: 'thin', color: { argb: 'DEE2E6' } }
                };
                
                cell.alignment = { 
                    horizontal: 'left', 
                    vertical: 'middle',
                    wrapText: true
                };
            });
        });
    }

    createSummarySection(sheet, data, config, startRow = 14) {
        const actualData = data.result;
        
        if (!actualData || actualData.length === 0) return;
        
        // Calculate summary statistics
        const totalAssets = actualData.length;
        const statusCounts = {};
        let totalValue = 0;
        
        actualData.forEach(item => {
            const status = item.functional_status_name || 'Unknown';
            statusCounts[status] = (statusCounts[status] || 0) + 1;
            
            if (item.cost && !isNaN(item.cost)) {
                totalValue += parseFloat(item.cost);
            }
        });
        
        // Create summary header - avoid overlapping with previous merges
        sheet.mergeCells(`A${startRow}:O${startRow}`);
        const summaryHeaderCell = sheet.getCell(`A${startRow}`);
        summaryHeaderCell.value = `SUMMARY STATISTICS - ${config.name.toUpperCase()}`;
        summaryHeaderCell.font = { 
            size: 16, 
            bold: true, 
            color: { argb: 'FFFFFF' },
            name: 'Calibri'
        };
        summaryHeaderCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: config.color.replace('#', '') }
        };
        summaryHeaderCell.alignment = { horizontal: 'center', vertical: 'middle' };
        
        // Summary cards layout
        const cardStartRow = startRow + 2;
        let cardCol = 1;
        
        // Total Assets Card
        this.createSummaryCard(sheet, cardStartRow, cardCol, 'TOTAL ASSETS', totalAssets, successColor, 'Assets');
        cardCol += 3;
        
        // Total Value Card
        this.createSummaryCard(sheet, cardStartRow, cardCol, 'TOTAL VALUE', `E${totalValue.toFixed(2)}`, primaryColor, 'Value');
        cardCol += 3;
        
        // Status breakdown cards
        let statusCardRow = cardStartRow + 4;
        Object.entries(statusCounts).forEach(([status, count], index) => {
            const color = config.statusColors?.[status] || darkGray;
            const percentage = ((count / totalAssets) * 100).toFixed(1);
            
            if (index % 4 === 0 && index > 0) {
                statusCardRow += 4;
            }
            
            const colPosition = 1 + (index % 4) * 3;
            this.createSummaryCard(sheet, statusCardRow, colPosition, status.toUpperCase(), `${count} (${percentage}%)`, color, 'Status');
        });
    }

    createSummaryCard(sheet, row, col, title, value, color, icon) {
        const endCol = col + 2;
        const endRow = row + 2;
        
        // Check if cells are already merged before attempting to merge
        try {
            // Only merge if the range is not already merged
            const startCell = sheet.getCell(row, col);
            if (!startCell.isMerged) {
                sheet.mergeCells(row, col, endRow, endCol);
            }
        } catch (error) {
            console.warn('Merge cells warning:', error.message);
            // Continue without merging if there's a conflict
        }
        
        // Create border and styling for all cells in the range
        for (let r = row; r <= endRow; r++) {
            for (let c = col; c <= endCol; c++) {
                const cell = sheet.getCell(r, c);
                cell.border = {
                    top: { style: 'medium', color: { argb: color.replace('#', '') } },
                    left: { style: 'medium', color: { argb: color.replace('#', '') } },
                    bottom: { style: 'medium', color: { argb: color.replace('#', '') } },
                    right: { style: 'medium', color: { argb: color.replace('#', '') } }
                };
                
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'F8F9FA' }
                };
            }
        }
        
        // Set content only on the top-left cell
        const cardCell = sheet.getCell(row, col);
        cardCell.value = `${icon} ${title}\n${value}`;
        cardCell.font = { 
            size: 10, 
            bold: true, 
            name: 'Calibri' 
        };
        cardCell.alignment = { 
            horizontal: 'center', 
            vertical: 'middle',
            wrapText: true
        };
    }

    createFooterSectionAtRow = (sheet, config, startRow) => {
        // Footer with generation info
        const footerRange = `A${startRow}:O${startRow + 1}`;
        try {
            sheet.mergeCells(footerRange);
            
            const footerCell = sheet.getCell(`A${startRow}`);
            footerCell.value = `Generated by Ministry of Health Asset Management System\n${util.getCurrentDateTime()} | Officer: ${UseDetails} | Report: ${config.name}`;
            footerCell.font = { 
                size: 8, 
                italic: true, 
                color: { argb: '6C757D' },
                name: 'Calibri'
            };
            footerCell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: lightGray.replace('#', '') }
            };
            footerCell.alignment = { 
                horizontal: 'center', 
                vertical: 'middle',
                wrapText: true
            };
            footerCell.border = {
                top: { style: 'medium', color: { argb: config.color.replace('#', '') } }
            };
        } catch (error) {
            console.warn('Footer merge warning:', error.message);
        }
    }

    createExecutiveSummaryAtRow = (sheet, data, config, stats, startRow) => {
        // Executive Summary Header
        const summaryRange = `A${startRow}:O${startRow}`;
        try {
            sheet.mergeCells(summaryRange);
            
            const summaryHeaderCell = sheet.getCell(`A${startRow}`);
            summaryHeaderCell.value = `EXECUTIVE SUMMARY - ${config.name.toUpperCase()}`;
            summaryHeaderCell.font = { 
                size: 14, 
                bold: true, 
                color: { argb: 'FFFFFF' },
                name: 'Calibri'
            };
            summaryHeaderCell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: accentColor.replace('#', '') }
            };
            summaryHeaderCell.alignment = { horizontal: 'center', vertical: 'middle' };
        } catch (error) {
            console.warn('Executive summary header merge warning:', error.message);
        }

        const summaryContentRow = startRow + 2;
        
        // Key insights - updated to use totalQuantity
        const insights = [
            `Total ${config.name}: ${stats.totalQuantity} items (${stats.total} records)`,
            `Total Value: ${this.formatCurrency(stats.totalValue)}`,
            `Average Value per Item: ${this.formatCurrency(stats.averageValue)}`,
            `Facilities Covered: ${stats.facilitiesCount}`,
            `Locations Tracked: ${stats.locationsCount}`
        ];

        if (stats.oldestAsset && stats.newestAsset) {
            insights.push(`Asset Age Range: ${this.formatDate(stats.oldestAsset)} to ${this.formatDate(stats.newestAsset)}`);
        }

        insights.forEach((insight, index) => {
            const cell = sheet.getCell(summaryContentRow + index, 1);
            cell.value = `• ${insight}`;
            cell.font = { size: 10, name: 'Calibri' };
            cell.alignment = { horizontal: 'left', vertical: 'middle' };
        });

        // Status distribution insights
        const functionalCount = stats.statusBreakdown['Functional'] || stats.statusBreakdown['Good condition'] || stats.statusBreakdown['Usable'] || 0;
        const functionalPercentage = stats.total > 0 ? ((functionalCount / stats.total) * 100).toFixed(1) : 0;
        
        const statusInsightCell = sheet.getCell(summaryContentRow + insights.length + 1, 1);
        statusInsightCell.value = `• Operational Status: ${functionalCount} functional (${functionalPercentage}%)`;
        statusInsightCell.font = { 
            size: 10, 
            bold: true, 
            color: { argb: functionalPercentage > 80 ? successColor.replace('#', '') : dangerColor.replace('#', '') },
            name: 'Calibri' 
        };
        statusInsightCell.alignment = { horizontal: 'left', vertical: 'middle' };
    }

    addDataValidationAtRow = (sheet, config, startRow) => {
        // Data Quality Section
        const validationRange = `A${startRow}:O${startRow}`;
        try {
            sheet.mergeCells(validationRange);
            
            const validationHeaderCell = sheet.getCell(`A${startRow}`);
            validationHeaderCell.value = `DATA QUALITY & VALIDATION`;
            validationHeaderCell.font = { 
                size: 12, 
                bold: true, 
                color: { argb: 'FFFFFF' },
                name: 'Calibri'
            };
            validationHeaderCell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: warningColor.replace('#', '') }
            };
            validationHeaderCell.alignment = { horizontal: 'center', vertical: 'middle' };
        } catch (error) {
            console.warn('Data validation header merge warning:', error.message);
        }

        const validationNotes = [
            'All mandatory fields validated',
            'Date formats standardized', 
            'Currency values formatted',
            'Status codes verified',
            `Generated: ${util.getCurrentDateTime()}`,
            `Source: ${config.name} Inventory Management System`
        ];

        validationNotes.forEach((note, index) => {
            const cell = sheet.getCell(startRow + 2 + index, 1);
            cell.value = `✓ ${note}`;
            cell.font = { size: 9, color: { argb: successColor.replace('#', '') }, name: 'Calibri' };
            cell.alignment = { horizontal: 'left', vertical: 'middle' };
        });
    }

    applyFinalFormatting(sheet, config) {
        // Set print settings
        sheet.pageSetup = {
            paperSize: 9, // A4
            orientation: 'landscape',
            fitToPage: true,
            fitToHeight: 1,
            fitToWidth: 1,
            margins: {
                left: 0.25,
                right: 0.25,
                top: 0.5,
                bottom: 0.5,
                header: 0.3,
                footer: 0.3
            }
        };
        
        // REMOVED: Freeze panes for better navigation
        // sheet.views = [
        //     { state: 'frozen', xSplit: 2, ySplit: 8 }
        // ];
        
        // Auto-filter for data table
        const rowCount = sheet.actualRowCount || 8;
        if (rowCount > 8) {
            try {
                const headerCount = Object.keys(config.headers).length;
                sheet.autoFilter = {
                    from: { row: 8, column: 1 },
                    to: { row: rowCount, column: headerCount }
                };
            } catch (error) {
                console.warn('Auto-filter warning:', error.message);
            }
        }
    }

    // Helper method to create bordered sections
    createBorderedSection = (sheet, startRow, startCol, endRow, endCol, fillColor = null) => {
        for (let row = startRow; row <= endRow; row++) {
            for (let col = startCol; col <= endCol; col++) {
                const cell = sheet.getCell(row, col);
                cell.border = {
                    top: { style: 'thin', color: { argb: '000000' } },
                    left: { style: 'thin', color: { argb: '000000' } },
                    bottom: { style: 'thin', color: { argb: '000000' } },
                    right: { style: 'thin', color: { argb: '000000' } }
                };
                
                if (fillColor) {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: fillColor.replace('#', '') }
                    };
                }
            }
        }
    }

    // Helper method to format currency
    formatCurrency = (value) => {
        if (!value || isNaN(value)) return 'E0.00';
        return `E${parseFloat(value).toLocaleString('en-US', { 
            minimumFractionDigits: 2,
            maximumFractionDigits: 2 
        })}`;
    }

    // Helper method to format dates
    formatDate = (dateValue) => {
        if (!dateValue) return 'N/A';
        
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return dateValue;
        
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    }

    // Helper method to get status icon
    getStatusIcon = (status, config) => {
        const statusIcons = {
            'Serviceable': '✅',
            'Partial functional': '⚠️',
            'Unserviceable': '❌',
            'Installed': '🔧',
            'Not installed': '📦',
            'Boarded': '🚫',
            'Good condition': '✅',
            'Fair': '⚠️',
            'Waiting for repairs': '🔧',
            'Awaiting for disposal': '🗑️',
            'Usable': '✅',
            'Expired': '❌'
        };
        
        return statusIcons[status] || '📋';
    }

    // Enhanced method to calculate detailed statistics
    calculateDetailedStatistics = (data, config) => {
        if (!data || data.length === 0) {
            return {
                total: 0,
                totalQuantity: 0,
                statusBreakdown: {},
                totalValue: 0,
                averageValue: 0,
                facilitiesCount: 0,
                locationsCount: 0
            };
        }

        const stats = {
            total: data.length,
            totalQuantity: 0,
            statusBreakdown: {},
            totalValue: 0,
            averageValue: 0,
            facilitiesCount: new Set(),
            locationsCount: new Set(),
            oldestAsset: null,
            newestAsset: null
        };

        data.forEach(item => {
            // Status breakdown
            const status = item.functional_status_name || 'Unknown';
            stats.statusBreakdown[status] = (stats.statusBreakdown[status] || 0) + 1;

            // Quantity calculation - sum the stock/quantity field
            if (item.stock && !isNaN(item.stock)) {
                stats.totalQuantity += parseInt(item.stock);
            } else if (item.quantity && !isNaN(item.quantity)) {
                stats.totalQuantity += parseInt(item.quantity);
            } else {
                // If no quantity specified, assume 1 per record
                stats.totalQuantity += 1;
            }

            // Value calculations
            if (item.cost && !isNaN(item.cost)) {
                stats.totalValue += parseFloat(item.cost);
            }

            // Facility tracking
            if (item.facility) {
                stats.facilitiesCount.add(item.facility);
            }

            // Location tracking
            if (item.station_points) {
                if (Array.isArray(item.station_points)) {
                    item.station_points.forEach(sp => stats.locationsCount.add(sp.station_point));
                } else if (typeof item.station_points === 'string') {
                    stats.locationsCount.add(item.station_points);
                }
            }

            // Date tracking for oldest/newest
            if (item.created) {
                const createdDate = new Date(item.created);
                if (!isNaN(createdDate.getTime())) {
                    if (!stats.oldestAsset || createdDate < new Date(stats.oldestAsset)) {
                        stats.oldestAsset = item.created;
                    }
                    if (!stats.newestAsset || createdDate > new Date(stats.newestAsset)) {
                        stats.newestAsset = item.created;
                    }
                }
            }
        });

        stats.averageValue = stats.total > 0 ? stats.totalValue / stats.total : 0;
        stats.facilitiesCount = stats.facilitiesCount.size;
        stats.locationsCount = stats.locationsCount.size;

        return stats;
    }

    // Method to add print-friendly formatting
    addPrintFormatting = (sheet, config) => {
        // Set page breaks for better printing
        sheet.pageSetup.printArea = `A1:O${sheet.actualRowCount}`;
        
        // Add headers and footers for printing
        sheet.headerFooter.oddHeader = `&C&14&B${config.title}`;
        sheet.headerFooter.oddFooter = `&L${config.name} Asset Register&C&P&RGenerated: ${util.getCurrentDate()}`;
        
        // Set row heights for readability
        sheet.properties.defaultRowHeight = 16;
        
        // Ensure key sections stay together
        sheet.pageSetup.horizontalCentered = true;
        sheet.pageSetup.verticalCentered = false;
    }

    getLoggedInUserNameAndSurnameAndDesignation = () => {
        UserService.profileDetail().then(res => { 
            UseDetails = res.data.result.fname + " " + res.data.result.lname;
            UserDesignation = res.data.result.title; 
        }).catch(e => {
            message.error(e.message);
        });
    }
}

const enhancedExcelReportUtil = new EnhancedExcelReportUtil();
export default enhancedExcelReportUtil;